import useAppStore from "@/context/store";
import { useGdInfo } from "./useGdInfo";

/**获取是否有某个权限 */
export function usePermission(
  code: string | string[]
): Record<string, boolean> | boolean {
  const userPermissions = useAppStore((s) => s.userPermissions);

  const { isGdMerged } = useGdInfo();

  if (!isGdMerged || !userPermissions) {
    // 未合并账号，不走king权限控制
    return true;
  }

  if (Array.isArray(code)) {
    return code.reduce((prev, cur) => (prev[cur] = userPermissions[cur]), {});
  }

  return userPermissions[code];
}

// /**
//  * 将组件封装加权限控制，有权限返回组件，没有权限渲染返回null
//  * @param code 权限点
//  * @param Component 封装的组件
//  */
// export function withPermissionHoc<P>(
//   code: string,
//   Component: React.ComponentType<P>
// ): React.FunctionComponent<P> {
//   return function WithPermissionHocComponent(props: P) {
//     const hasPermission = usePermission(code);
//     return hasPermission ? <Component {...props} /> : null;
//   };
// }

export const hasPermission = (code: string | string[]) => {
  const userPermissions = useAppStore.getState().userPermissions;

  if (Array.isArray(code)) {
    return code.reduce((prev, cur) => (prev[cur] = userPermissions[cur]), {});
  }

  return userPermissions[code];
};
